import { Link } from "react-router-dom";
import Logo from "./Logo";
import { COMPANY, CITIES, STATIC_PAGES } from "@/lib/constants";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

const Footer = () => (
  <footer className="grain border-t border-white/10 bg-graph" data-testid="footer">
    <div className="paver-bg">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-stonemute">
              Perfekcjonizm, profesjonalizm i rzetelność. Kostka brukowa, płyty tarasowe, brukarstwo artystyczne — od A do Z, z pomocą w projekcie i doborze materiałów.
            </p>
          </div>

          <div data-testid="footer-contact">
            <p className="eyebrow mb-5">Kontakt</p>
            <ul className="space-y-3 text-pearl">
              <li>
                <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone" className="font-display text-3xl font-bold tracking-wide transition-colors duration-300 hover:text-amber">
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 text-sm text-stonemute transition-colors duration-300 hover:text-[#25D366]">
                  <WhatsAppIcon className="text-[#25D366]" />
                  Napisz na WhatsApp
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="text-sm transition-colors duration-300 hover:text-amber">
                  {COMPANY.email}
                </a>
              </li>
              <li className="text-sm text-stonemute">
                {COMPANY.street}
                <br />
                {COMPANY.postal}
              </li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-5">Nawigacja</p>
            <ul className="space-y-2">
              {STATIC_PAGES.map((p) => (
                <li key={p.path}>
                  <Link to={p.path} data-testid={`footer-link-${p.path.replace("/", "") || "home"}`} className="text-sm text-stonemute transition-colors duration-300 hover:text-amber">
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/5 pt-8">
          <p className="text-xs leading-relaxed text-stonemute">
            Usługi brukarskie na terenie: {CITIES.join(", ")} i okolic — układanie kostki brukowej, płyty tarasowe, płyty ceramiczne, płyty chodnikowe, palisady, obrzeża. Podjazdy, parkingi, opaski, tarasy, chodniki, nawierzchnie pod garaże i altany. Brukarstwo artystyczne.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-stonemute">
            © {new Date().getFullYear()} {COMPANY.fullName} · {COMPANY.site.replace("https://", "")}
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
